import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Mail, Send } from "lucide-react";

// Compose-and-send dialog for one-off admin → user emails. Parent owns the
// recipient + form state so closing the dialog mid-send is a controlled op.
export default function EmailUserDialog({ emailFor, setEmailFor, emailForm, setEmailForm, emailSending, sendCustomEmail }) {
  return (
    <Dialog open={!!emailFor} onOpenChange={(o) => { if (!o && !emailSending) { setEmailFor(null); setEmailForm({ subject: "", body: "" }); } }}>
      <DialogContent className="rounded-3xl bg-cream max-w-xl" data-testid="email-user-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-forest flex items-center gap-2">
            <Mail className="w-5 h-5 text-sage-dark" />
            <span>Email {emailFor?.name || "user"}</span>
          </DialogTitle>
          <DialogDescription className="text-forest/60" data-testid="email-user-recipient">
            Sending to <strong>{emailFor?.email}</strong>
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-2">
          <div>
            <Label className="text-forest/80">Subject</Label>
            <Input
              value={emailForm.subject}
              onChange={(e) => setEmailForm({ ...emailForm, subject: e.target.value })}
              maxLength={200}
              placeholder="A short subject line"
              className="mt-1 rounded-xl bg-softstone/60 border-sage/30"
              data-testid="email-user-subject"
              disabled={emailSending}
            />
          </div>
          <div>
            <Label className="text-forest/80">Message</Label>
            <Textarea
              value={emailForm.body}
              onChange={(e) => setEmailForm({ ...emailForm, body: e.target.value })}
              maxLength={5000}
              rows={8}
              placeholder="Write your message to this user..."
              className="mt-1 rounded-xl bg-softstone/60 border-sage/30"
              data-testid="email-user-body"
              disabled={emailSending}
            />
            <p className="mt-1 text-[11px] text-forest/50">
              Sent from {`"Compass Kids"`} — the user can reply directly to your team address.
            </p>
          </div>
          <div className="flex items-center justify-end gap-2 pt-2">
            <Button
              variant="ghost"
              className="rounded-full text-forest/70"
              onClick={() => { setEmailFor(null); setEmailForm({ subject: "", body: "" }); }}
              disabled={emailSending}
              data-testid="email-user-cancel"
            >
              Cancel
            </Button>
            <Button
              onClick={sendCustomEmail}
              className="rounded-full bg-sage hover:bg-sage-dark text-white inline-flex items-center gap-2"
              disabled={emailSending}
              data-testid="email-user-send"
            >
              <Send className="w-4 h-4" /> {emailSending ? "Sending..." : "Send email"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
